/**
 * API поиска товаров для продажи в общем каталоге по ресурсу «Собственная»: текстовый запрос или штрихкод.
 * Только чтение; данные кэшируются по ресурсу.
 */
import { baseApi, resourceScopeTag } from '@krp/client-runtime'

import { decodeOwnSearchPage, type OwnSearchPage } from './searchContracts'
import { OWN_CATALOG_URLS } from './urls'

export interface OwnSaleSearchArgs {
  /** Ресурс «Собственная»: право `session.open` проверяется на нём. */
  resourceId: string
  q: string
  mode?: 'text' | 'barcode'
  limit?: number
}

export const ownCatalogApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Поиск товаров для продажи в общем каталоге. Цен и ставок НДС здесь нет: их отдаёт отдельная проекция «строк для продажи». */
    ownSaleSearch: build.query<OwnSearchPage, OwnSaleSearchArgs>({
      query: ({ resourceId, q, mode, limit }) => ({
        url: OWN_CATALOG_URLS.saleSearch(),
        params: { resourceId, q, mode: mode ?? 'text', ...(limit === undefined ? {} : { limit }) },
        decode: decodeOwnSearchPage,
      }),
      providesTags: (_result, _error, { resourceId }) => [resourceScopeTag(resourceId)],
    }),
  }),
})

export const { ownSaleSearch } = ownCatalogApi.endpoints